import { SR_API_ACTION_HOUSEHOLD_APPLICATION_GET_BY_USER_ID } from 'api/actionTypes';

// Gets the householdApplications that belongs to an user.
export default async function getHouseholdApplicationsByUserId({ state, apiClient }, { userId }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_APPLICATION_GET_BY_USER_ID,
    state: state,
    payload: {
      userId,
    },
    onSuccess(householdApplications) {
      state.set(['household', 'applicationsByUserId', userId], householdApplications);
      return householdApplications;
    },
  });
}
